/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 利用実績
 * @export
 * @interface ChargeableTripsRow
 */
export interface ChargeableTripsRow {
    /**
     * 営業所ID
     * @type {number}
     * @memberof ChargeableTripsRow
     */
    officeId: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    officeName: string;
    /**
     * 乗務日
     * @type {number}
     * @memberof ChargeableTripsRow
     */
    shiftDate: number;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ChargeableTripsRow
     */
    driverId: number;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    driverCode: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    driverName: string;
    /**
     * 乗車時刻
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    deliverStartedAt?: string;
    /**
     * 開始時刻
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    unladenTripStartedAt: string;
    /**
     * 開始地点
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    startLocation?: string;
    /**
     * 乗車地点
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    deliveredLocation?: string;
    /**
     * 乗車種別
     * @type {number}
     * @memberof ChargeableTripsRow
     */
    rideType?: number;
    /**
     * 実車時ナビ利用
     * @type {boolean}
     * @memberof ChargeableTripsRow
     */
    useNaviAtDelivered?: boolean;
    /**
     * 実車前ナビオフ時間
     * @type {number}
     * @memberof ChargeableTripsRow
     */
    deliveredDurationAfterNaviOff?: number;
    /**
     * trip session id
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    tripSessionId?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    loginSessionId?: string;
    /**
     * 走った軌跡のshape
     * @type {object}
     * @memberof ChargeableTripsRow
     */
    unladenShape?: object;
    /**
     * hermes経路のshape
     * @type {object}
     * @memberof ChargeableTripsRow
     */
    naviShape?: object;
    /**
     * 空車開始地点の座標
     * @type {object}
     * @memberof ChargeableTripsRow
     */
    unladenStartLoc?: object;
    /**
     * 実車開始地点の座標
     * @type {object}
     * @memberof ChargeableTripsRow
     */
    deliverStartLoc?: object;
    /**
     * 乗車種別 (cruising/stand/go/tel/cancel_tel/homing/error)
     * @type {string}
     * @memberof ChargeableTripsRow
     */
    boardingType?: string;
}

export function ChargeableTripsRowFromJSON(json: any): ChargeableTripsRow {
    return ChargeableTripsRowFromJSONTyped(json, false);
}

export function ChargeableTripsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChargeableTripsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': json['office_id'],
        'officeName': json['office_name'],
        'shiftDate': json['shift_date'],
        'driverId': json['driver_id'],
        'driverCode': json['driver_code'],
        'driverName': json['driver_name'],
        'deliverStartedAt': !exists(json, 'deliver_started_at') ? undefined : json['deliver_started_at'],
        'unladenTripStartedAt': json['unladen_trip_started_at'],
        'startLocation': !exists(json, 'start_location') ? undefined : json['start_location'],
        'deliveredLocation': !exists(json, 'delivered_location') ? undefined : json['delivered_location'],
        'rideType': !exists(json, 'ride_type') ? undefined : json['ride_type'],
        'useNaviAtDelivered': !exists(json, 'use_navi_at_delivered') ? undefined : json['use_navi_at_delivered'],
        'deliveredDurationAfterNaviOff': !exists(json, 'delivered_duration_after_navi_off') ? undefined : json['delivered_duration_after_navi_off'],
        'tripSessionId': !exists(json, 'trip_session_id') ? undefined : json['trip_session_id'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
        'unladenShape': !exists(json, 'unladen_shape') ? undefined : json['unladen_shape'],
        'naviShape': !exists(json, 'navi_shape') ? undefined : json['navi_shape'],
        'unladenStartLoc': !exists(json, 'unladen_start_loc') ? undefined : json['unladen_start_loc'],
        'deliverStartLoc': !exists(json, 'deliver_start_loc') ? undefined : json['deliver_start_loc'],
        'boardingType': !exists(json, 'boarding_type') ? undefined : json['boarding_type'],
    };
}

export function ChargeableTripsRowToJSON(value?: ChargeableTripsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_name': value.officeName,
        'shift_date': value.shiftDate,
        'driver_id': value.driverId,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'deliver_started_at': value.deliverStartedAt,
        'unladen_trip_started_at': value.unladenTripStartedAt,
        'start_location': value.startLocation,
        'delivered_location': value.deliveredLocation,
        'ride_type': value.rideType,
        'use_navi_at_delivered': value.useNaviAtDelivered,
        'delivered_duration_after_navi_off': value.deliveredDurationAfterNaviOff,
        'trip_session_id': value.tripSessionId,
        'login_session_id': value.loginSessionId,
        'unladen_shape': value.unladenShape,
        'navi_shape': value.naviShape,
        'unladen_start_loc': value.unladenStartLoc,
        'deliver_start_loc': value.deliverStartLoc,
        'boarding_type': value.boardingType,
    };
}


